export default __webpack_public_path__ + "static/media/BackgroundAzulMobile.e090ebe8.png";